// frontend/src/contexts/BillingStatusContext.js
//
// The selected store's billing status, for the screens inside the app.
//
// ProtectedLayout (App.jsx) reads the store's billing status ONCE per store,
// as the billing part of the entry read (`hooks/useEntryStatus`), to decide
// paywall-or-app. Once it lets the app through, it provides that same answer
// here, so the Plans page and the app-wide plan-change banner read the status
// the gate already vouched for instead of a second copy of it.
//
// Value: `{ status, refresh }` — `status` is the raw payload, never null
// inside the app; `refresh()` re-reads `/api/billing/status/` alone without
// unmounting the app. `null` where billing does not apply (no Shopify store
// selected).

import { createContext, useContext } from 'react';

export const BillingStatusContext = createContext(null);

export function useBillingStatusContext() {
  return useContext(BillingStatusContext);
}
